export const defaultState = {
  id: null,
  certificateHolder: null,
  certificateLevelDomain: null,
  certificationBody: null,
  issueDate: null,
  type: null,
  validUntil: null,
  certId: '',
  holderAuthorized: null,
  visibility: null,
  otherSignatures: [],
  headSignature: null,
  assessorSignature: null,
  signatureOptions: [],
  language: null
};

const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    if (action.payload.name === 'issueDate') {
      const newValidUnitil = new Date(action.payload.value);
      newValidUnitil.setFullYear(newValidUnitil.getFullYear() + 5);
      newValidUnitil.setDate(newValidUnitil.getDate() - 1);
      return { ...state, [action.payload.name]: action.payload.value, validUntil: newValidUnitil };
    }
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
